<template>
	<div class="container admin-table-page">
		<div class="param-title-wrap">
			<b-button class="page-back-btn mr-2" variant="link" @click="cierraModal">
				<font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
			</b-button>
			<h2 class="param-title">{{ labels.titulo1 }}</h2>
		</div>
		<div class="admin-table-block mt-4">
			<div class="formulario-scroll">
				<b-row class="formulario-row">
					<b-col cols="12">
						<b-form id="create-form" class="formulario-form">
							<b-form-group>
								<div class="formulario-card-section">
									<div class="formulario-card-header">
										Empresa
									</div>
									<div class="formulario-card-body">
										<div class="formulario-row-grid" :style="{ '--formulario-columns': 6 }">
											<div class="formulario-field">
												<text> Nit: {{ compania.nit}}</text>
											</div>
											<div class="formulario-field">
												<text> {{compania.razon_social}} </text>
											</div>
											<div class="formulario-field">
												<text> {{compania.compania_departamento}} </text>
											</div>
											<div class="formulario-field">
												<text> {{compania.compania_municipio}} </text>
											</div>
											<div class="formulario-field">
												<text> {{compania.direccion}} </text>
											</div>
										</div>
									</div>
								</div>
								<div class="formulario-card-section">
									<div class="formulario-card-header">
										Ciius
									</div>
									<CorporateDataTable 
										:items="companiaCiius"
										:fields="allFieldsCiius"
										:labels="tableLabels"
										:default-per-page="10"
										:page-options="[10, 20, 50, 100]"
										:narrow="false"
										:table-min-height="500"
										:table-max-height="500"
										:showSearch="false"
										:enable-sorting="false"
										:allowColumnToggle="false"
									>
									</CorporateDataTable>
								</div>
								<div class="formulario-card-section">
									<div class="formulario-card-header">
										Municipios
									</div>
									<CorporateDataTable 
										:items="companiaMunicipios"
										:fields="allFieldsMunicipios"
										:labels="tableLabels"
										:default-per-page="10"
										:page-options="[10, 20, 50, 100]"
										:narrow="false"
										:table-min-height="500"
										:table-max-height="500"
										:showSearch="false"
										:enable-sorting="false"
										:allowColumnToggle="false"
									>
										<template #toolbar-actions>
											<b-button v-if="this.$route.name == 'sinasignar'" size="sm" class="table-toolbar-add-btn" @click="createFactura()">
											{{ labels.create }} 
											</b-button>
										</template>
										<template #cell(info)="data">
											<b-button
												style="background-color: #00008B; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="showInfo(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'list']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(edit)="data">
											<b-button
												style="background-color: #e5ac00; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="editFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'list']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(dec)="data">
											<b-button
												style="background-color: #ff0000; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="deleteFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'trash']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(estado)="data">
											<b-button
												style="background-color: #008000; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="estadoFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'check']" size="xs"/></i>
											</b-button>
										</template>
									</CorporateDataTable>
								</div>
								<div class="formulario-card-section">
									<div class="formulario-card-header">
										CIIUS POR MUNICIPIO
									</div>
									<CorporateDataTable 
										:items="companiaMunicipiosCiius"
										:fields="allFieldsMunicipiosCiius"
										:labels="tableLabels"
										:default-per-page="10"
										:page-options="[10, 20, 50, 100]"
										:narrow="false"
										:table-min-height="500"
										:table-max-height="500"
										:showSearch="false"
										:enable-sorting="false"
										:allowColumnToggle="false"
									>
										<template #toolbar-actions>
											<b-button v-if="this.$route.name == 'sinasignar'" size="sm" class="table-toolbar-add-btn" @click="createFactura()">
											{{ labels.create }} 
											</b-button>
										</template>
										<template #cell(info)="data">
											<b-button
												style="background-color: #00008B; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="showInfo(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'list']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(edit)="data">
											<b-button
												style="background-color: #e5ac00; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="editFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'list']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(dec)="data">
											<b-button
												style="background-color: #ff0000; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="deleteFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'trash']" size="xs"/></i>
											</b-button>
										</template>
										<template #cell(estado)="data">
											<b-button
												style="background-color: #008000; width: 30px; height: 30px;"
												class="md-fab md-primary"
												@click="estadoFactura(data.item)" 
											>
												<i><font-awesome-icon :icon="['fas', 'check']" size="xs"/></i>
											</b-button>
										</template>
									</CorporateDataTable>
								</div>
							</b-form-group>
						</b-form>
					</b-col	>
				</b-row>
			</div>
		</div>
	</div>
</template>
<script>
import Companias from "@/services/Compania";
import Divipol from "@/services/Divipol";
import Ciius from "@/services/Ciius";
import CorporateDataTable from "../utils/CorporateDataTable.vue"
export default {
name: 'Compania',
components: {
	CorporateDataTable,
},
data() {
	return	{
		compania: {},
		companiaMunicipios: [],
		companiaCiius: [],
		companiaMunicipiosCiius: [],
		departamentos: [],
		municipios: [],
		ciius: [],
		isLoading: false,
	}
},
methods: {
	itemCompania() {
		this.compania.compania_departamento =this.f_departamento(this.compania.divipol_depto)
		this.compania.compania_municipio = this.f_municipio(this.compania.divipol_depto,this.compania.divipol_municipio)
	},
	f_departamento(p_departamento) {
		const c_departamento = this.departamentos.find((r_departamento) => r_departamento.divipol_depto==p_departamento)
		const v_descripcion = c_departamento ? c_departamento.descripcion : "Departamento "+p_departamento
		return v_descripcion
	},
	f_municipio(p_departamento,p_municipio) {
		const r_municipio = this.municipios.find((r_municipio) => r_municipio.divipol_depto==p_departamento && 
									r_municipio.divipol_municipio==p_municipio)
		const v_descripcion = r_municipio ? r_municipio.descripcion : "Municipio "+p_departamento+" "+p_municipio
		return v_descripcion
	},
},
computed: {
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			titulo1: "Industria y Comercio",
			compania: "Compañia",
			companiaMunicipios: "Municipios",
			companiaCiius: "Ciius",
			companiaMunicipiosCiius: "Ciius por Compania",
		};
	} else {
		return {
			compania: "Compañia",
			companiaMunicipios: "Municipios",
			companiaCiius: "Ciius",
			companiaMunicipiosCiius: "Ciius por Compania",
		};
	}
},
},
allFieldsCiius() {
	return [
		{ key: 'ciiu', label: this.labels.ciiu, sortable: false },
		{ key: 'alterno', label: this.labels.alterno, sortable: false, tdClass: 'nowrap-cell'},
		{ key: 'descripcion', label: this.labels.descripcion, sortable: false, tdClass: 'nowrap-cell'},
	]
},
allFieldsMunicipios() {
	return [
		{ key: 'divipol_depto', label: this.labels.departamento, sortable: false },
		{ key: 'divipol_municipio', label: this.labels.municipio, sortable: false },
	]
},
allFieldsMunicipiosCiius() {
	return [
		{ key: 'divipol_depto', label: this.labels.departamento, sortable: false },
		{ key: 'divipol_municipio', label: this.labels.municipio, sortable: false },
		{ key: 'ciiu', label: this.labels.ciiu, sortable: false },
		{ key: 'alterno', label: this.labels.alterno, sortable: false, tdClass: 'nowrap-cell'},
	]
},
tableLabels() {
return {
        noRow: this.labels.empty,
        noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
        noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
        sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
        showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
        filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
        clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
      };
},
mounted(){
	this.isLoading = true;
	Promise.all([
		Companias.leaCompania(),
		Companias.leaCompaniaMunicipios(),
		Companias.leaCompaniaCiius(),
		Companias.leaCompaniaMunicipiosCiius(),
		Divipol.leaDepartamentos(),
		Divipol.leaMunicipios(),
		Ciius.leaCiius(),
	])
	.then(([companiaRes,companiaMunicipiosRes,companiaCiiusRes,companiaMunicipiosCiiusRes,departamentoRes,municipiosRes,ciiusRes]) => { 
		this.compania = companiaRes.data.compania[0] || {};
		this.companiaMunicipios = companiaMunicipiosRes.data.companiaMunicipio || [];
		this.companiaCiius = companiaCiiusRes.data.companiaCiius || [];
		this.companiaMunicipiosCiius = companiaMunicipiosCiiusRes.data.companiaMunicipiosCiius || [];
		this.departamentos = departamentoRes.data.departamento || [];
		this.municipios = municipiosRes.data.municipio || [];
		this.ciius = ciiusRes.data.ciius || [];
		this.itemCompania()
		this.isLoading = false;
	})
	.catch((e) => { 
		console.log("Error: "+e);
		this.error = true;
		this.isLoading = false;
	});
}
};
</script>

<style src="../formulario.css" > </style>
<style scoped>
:deep(.nowrap-cell) {
  font-size: 13px !important;
  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
}
</style>
